import { render, staticRenderFns } from "./ShowDeveloperClientSecretModal.vue?vue&type=template&id=2230d88a&scoped=true&lang=pug"
import script from "./ShowDeveloperClientSecretModal.vue?vue&type=script&lang=js"
export * from "./ShowDeveloperClientSecretModal.vue?vue&type=script&lang=js"
import style0 from "./ShowDeveloperClientSecretModal.vue?vue&type=style&index=0&id=2230d88a&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2230d88a",
  null
  
)

export default component.exports